import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 68312 72359"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:770.849}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g>
      <g id="_1974336606160">
        <path
          d="M51216 45505c3031 0 5488 2539 5488 5673 0 3132-2457 5672-5488 5672-284 0-564-23-836-65-712 1373-2114 2306-3726 2306-2335 0-4228-1956-4228-4368 0-2102 1435-3855 3346-4275 346-2788 2652-4943 5444-4943zM16716 45505c-3032 0-5489 2539-5489 5673 0 3132 2457 5672 5489 5672 283 0 562-23 834-65 713 1373 2115 2306 3728 2306 2334 0 4228-1956 4228-4368 0-2102-1436-3855-3347-4275-347-2788-2651-4943-5443-4943zM37803 23796c113 281 330 527 591 677 688 924 1095 2068 1095 3309 0 3064-2483 5548-5547 5548-72 0-143-2-214-3-71 1-142 3-214 3-3063 0-5547-2484-5547-5548 0-1241 408-2385 1096-3309 260-150 476-396 590-677l42-115 32-136 19-143 1-126c-12-212-45-378-169-621-754-598-1383-1354-1842-2221l-2-6c-91-173-176-351-253-533l-5-10-29-70-34-85-16-44-19-47-23-59-10-28-39-112-13-36-18-53-15-44-31-98-16-50-10-36-18-64-13-48-19-70-11-40-25-96-5-24-20-82-7-31-22-103-6-29-17-83-6-34-15-84-7-39-15-88-6-40-12-82-3-23-16-115-1-14-11-93-4-37-8-87-3-34-8-109v-10l-7-107-2-19-4-120v-4l-3-101-1-39-1-113c0-3893 3054-7050 6821-7050 3766 0 6820 3157 6820 7050v113l-1 39-3 101v4l-5 120-1 19-7 107v10l-8 109-3 34-9 87-3 37-11 93-1 14-16 115-3 23-12 82-7 40-14 88-7 39-15 84-6 34-17 83-6 29-23 103-6 31-20 82-5 24-24 96-11 40-20 70-14 48-18 64-10 36-15 50-32 98-15 44-17 53-13 36-39 112-10 28-23 59-18 47-17 44-35 85-29 70-4 10c-77 182-162 360-253 533l-2 6c-459 867-1088 1623-1842 2221-124 243-157 409-169 621l1 126 18 143 33 136 42 115z"
          className="fill stroke1"
          style={{
            strokeWidth: 770.849,
          }}

        />
        <path
          d="M1784 1784h64744v68790H1784z"
          style={{
            fill: "none",
            // stroke: "#2b2a29",
            strokeWidth: 3568.97,
          }}
          className="stroke1"
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
